import React from 'react'
import PropTypes from 'prop-types'
import { Wrapper } from './UG004.styles'
import UGLayout from '../../../helpers/UGLayout'
import { ComponentHelper } from '../../../helpers/ComponentHelper'

/**
 UG004 is the Universal Grid for rendering minimum 2 product cards in a stacked or slider layout for both desktop and mobile.

  - Mobile view has two items side by side on each row when a stacked layout is chosen, and two items per slide when the slider layout is chosen.
  - Tablet view has three items side by side on each row when a stacked layout is chosen, and three items per slide when the slider layout is chosen.
  - Desktop view has four items side by side on each row when a stacked layout is chosen, and four items per slide when the slider layout is chosen.
* */
const UG004 = ({ consumingGridType, included, layout }) => {
  const minLength = 2
  const numberOfComponents = included.length
  const validIncludedComponents = ComponentHelper.validComponentArrayOfObjects(included)
  if (numberOfComponents < minLength || validIncludedComponents.length === 0) return null

  const UGLayoutProps = { consumingGridType, included: validIncludedComponents, layout }

  if (layout === 'slider') {
    return (
      <Wrapper negative='xs' gutterSize='0' data-test='ug004-wrapper'>
        <UGLayout {...UGLayoutProps} />
      </Wrapper>
    )
  }

  return <UGLayout {...UGLayoutProps} />
}

UG004.propTypes = {
  /** name of the grid passed down to child components. defaults to UG004 */
  consumingGridType: PropTypes.string,
  /** Array of child components to be rendered inside the grid */
  included: PropTypes.arrayOf(PropTypes.shape).isRequired,
  /** layout of the grid components when displayed on all screens  */
  layout: PropTypes.oneOf(['slider', 'stack'])
}

UG004.defaultProps = {
  consumingGridType: 'ug004',
  layout: 'stack'
}

export default UG004
